var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.HasLoadedItem === true)?_c('div',{staticClass:"col-12 page-full-item"},[_c('div',{staticClass:"content-wrapper news-wrapper",domProps:{"innerHTML":_vm._s(_vm.NewsItem.full)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }